<template>
	<v-card>
		<v-container>
			<v-toolbar-title class="mb-4">Perfil</v-toolbar-title>
			<v-row>
				<v-col cols="12" sm="auto" class="text-center d-flex flex-column align-center">
					<v-avatar size="90">
						<img
							v-if="fotoIrmao(irmao)"
							:src="fotoIrmao(irmao)"
							style="object-fit: cover"
						/>
						<v-icon
							v-else
							v-text="'mdi-account'"
							size="90"
						/>
					</v-avatar>
					<v-menu offset-y>
						<template v-slot:activator="{ on }">
							<v-btn
								outlined
								color="primary"
								v-on="on"
								class="mt-2"
							>
								Alterar Foto
							</v-btn>
						</template>
						<v-list>
							<v-list-item @click="() => fotoInput.click()">
								Enviar Novo
							</v-list-item>
							<v-list-item v-if="fotoIrmao(irmao)" @click="() => removerFoto(irmao)">
								Remover
							</v-list-item>
						</v-list>
					</v-menu>
					<input
						type="file"
						accept="image/*"
						ref="fotoInput"
						style="display: none;"
						@change="onFotoChange"
					>
				</v-col>
				<v-col>
					<v-row>
						<v-col cols="12">
							<v-text-field
								label="Nome Completo*"
								v-model="irmao.nomeCompleto"
								:rules="[ obrigatorio ]"
								required
							/>
						</v-col>
						<v-col cols="4" sm="6">
							<v-text-field
								label="CIM*"
								v-model.number="irmao.cim"
								pattern="[0-9]*"
								inputmode="numeric"
								:rules="[ obrigatorio ]"
								required
								:disabled="intersectRoles(authModule.role, 'basic')"
							/>
						</v-col>
						<v-col cols="8" sm="6">
							<SeletorDeGrauDoMacon
								label="Grau*"
								v-model="irmao.grauMacon"
								:rules="[ obrigatorio ]"
								required
								:disabled="intersectRoles(authModule.role, 'basic')"
							/>
						</v-col>
						<v-col cols="4" sm="6">
							<SeletorDePotencia
								v-model="irmao.potencia"
								:rules="[ obrigatorio ]"
								:disabled="true || !intersectRoles(authModule.role, 'admin') && !intersectRoles(authModule.role, 'admin-potencia')"
							/>
						</v-col>
						<v-col cols="8" sm="6">
							<v-text-field
								label="Cargo da Potência"
								v-model="irmao.cargoDeAdminDaPotencia"
								:disabled="!intersectRoles(authModule.role, 'admin') && !intersectRoles(authModule.role, 'admin-potencia')"
							/>
						</v-col>
						<v-col cols="12" sm="6">
							<v-text-field
								label="Nascimento"
								v-model="irmao.dataDeNascimento"
								type="date"
								name="bday"
							/>
						</v-col>
						<v-col cols="12" sm="6">
							<SeletorDeCidade
								label="Cidade"
								v-model="irmao.cidade"
								clearable
							/>
						</v-col>
					</v-row>
				</v-col>
			</v-row>
		</v-container>
	</v-card>
</template>

<script lang="ts">
export default {
	model: {
		prop: 'irmao',
	},
}
</script>

<script setup lang="ts">
import { computed, PropType, ref, watch } from 'vue'
import { authModule } from '@/store'
import { obrigatorio } from '@/shareds/regras'
import { intersectRoles } from '@/helpers/auth-helpers'
import { InputIrmao } from 'common/types/Irmao'
import SeletorDePotencia from '@/components/SeletorDePotencia.vue'
import SeletorDeGrauDoMacon from '@/components/SeletorDeGrauDoMacon.vue'
import SeletorDeCidade from '@/components/seletores/SeletorDeCidade.vue'

const props = defineProps({
	irmao: { type: Object as PropType<InputIrmao>, required: true },
	novaFoto: { type: null as unknown as PropType<File | null> },
})

const emit = defineEmits<{
	(e: 'update:novaFoto', foto: File | null): void
}>()

const syncNovaFoto = computed({
	get: () => props.novaFoto,
	set: (foto: File | null | undefined) => emit('update:novaFoto', foto ?? null),
})

const fotoPreview = ref('')

const fotoInput = ref<HTMLInputElement>()

function onFotoChange() {
	const input = fotoInput.value!
	if (!input.files) return
	const [file] = input.files
	syncNovaFoto.value = file
}

watch(() => props.novaFoto, (novaFoto) => {
	if (!novaFoto) {
		fotoPreview.value = ''
		return
	}
	const reader = new FileReader()

	reader.addEventListener('load', () => {
		fotoPreview.value = reader.result as string
	}, false)

	reader.readAsDataURL(novaFoto)
}, { immediate: true })

function fotoIrmao(irmao: InputIrmao) {
	return fotoPreview.value || irmao.foto
}

function removerFoto(irmao: InputIrmao) {
	irmao.foto = ''
	syncNovaFoto.value = null
}
</script>
